import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { DropInteractionParams, DropLocation } from "../Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import React from "react";
import DefaultParticipationDrop from "./DefaultParticipationDrop";
import MemeParticipationDrop from "@/components/memes/drops/MemeParticipationDrop";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
interface ParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
}
export default function ParticipationDrop(props) {
  const $ = _c(4);
  const {
    drop
  } = props;
  const {
    isMemesWave
  } = useSeizeSettings();
  if (isMemesWave(drop.wave?.id?.toLowerCase())) {
    let t0;
    if ($[0] !== props) {
      t0 = <MemeParticipationDrop {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    let t0;
    if ($[2] !== props) {
      t0 = <DefaultParticipationDrop {...props} />;
      $[2] = props;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    return t0;
  }
}